import React, { useEffect, useState } from "react";
import { setPageMeta } from "../seo/setPageMeta";

export default function Stories() {
  const API_URL = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(false);

  useEffect(() => {
    setPageMeta({
      title: "Stories of Hope | Celebrate Recovery Independence KY",
      description:
        "Read stories of hope and transformation from Celebrate Recovery in Independence, Kentucky. Discover testimonies of healing, grace, and new life.",
      canonical: "https://www.crindependenceky.com/stories",
    });

    fetchStories();
  }, []);

  async function fetchStories() {
    try {
      const response = await fetch(`${API_URL}/api/stories`);
      const data = await response.json();
      setStories(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Failed to fetch stories:", error);
      setFetchError(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <section>
      <h2 className="page-title">Stories of Hope</h2>
      <p className="page-intro">
        Testimonies remind us that healing is possible and that God is still at
        work in every life.
      </p>

      <div className="card section-spacing">
        <h3>Share What God Has Done</h3>
        <p>
          This page highlights written testimonies, speaker highlights, and
          stories of personal transformation from the ministry.
        </p>
        <p className="quote-box">
          “Recovery begins when honesty, grace, and hope meet in one place.”
        </p>
      </div>

      <div className="section-spacing">
        {loading ? (
          <p className="page-intro">Loading stories...</p>
        ) : fetchError ? (
          <div className="card">
            <p className="status-message status-error">
              Could not load stories. Please refresh the page.
            </p>
          </div>
        ) : stories.length === 0 ? (
          <div className="card">
            <h3>No stories have been shared yet.</h3>
            <p>Check back soon for testimonies and stories of hope.</p>
          </div>
        ) : (
          <div className="video-list">
            {stories.map((item) => (
              <div key={item._id} className="card">
                <h3>{item.title}</h3>
                <p className="video-meta">
                  {item.anonymous ? "Anonymous" : item.name}
                </p>
                <p>{item.story}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}